export type ResearcherOption = {
  id: string;
  name: string;
};

export type ResolvedAssignee = {
  isAssigned: boolean;
  isFlagged: boolean;
  displayName: string;
};

const UNKNOWN_RESEARCHER_NAME = "Unknown researcher";

/**
 * Role-neutral on purpose: the same lookup serves the researcher cell and the editor cell, which both
 * draw their candidates from the researcher list. Naming the id after one role invites passing an
 * editor id into a researcher-shaped parameter.
 */
export function resolveAssignee(input: {
  assigneeId: string | null;
  researchers: ResearcherOption[];
  resolvedNames: Record<string, string>;
}): ResolvedAssignee {
  const { assigneeId, researchers, resolvedNames } = input;

  if (!assigneeId) {
    return { isAssigned: false, isFlagged: false, displayName: "" };
  }

  const activeResearcher = researchers.find(researcher => researcher.id === assigneeId);
  if (activeResearcher) {
    return { isAssigned: true, isFlagged: false, displayName: activeResearcher.name };
  }

  const resolvedName = resolvedNames[assigneeId];
  return {
    isAssigned: true,
    isFlagged: true,
    displayName: resolvedName ?? UNKNOWN_RESEARCHER_NAME,
  };
}
